import { Navigate, useNavigate, useSearch } from "@tanstack/react-router";
import type React from "react";
import { useIsAdmin } from "@/auth/useIsAdmin";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { AirportsTab } from "./AirportsTab";
import { CrewTab } from "./CrewTab";
import { RatesTab } from "./RatesTab";
import { TierEquivalenciesTab } from "./TierEquivalenciesTab";

type SettingsTab = "crew" | "rates" | "airports" | "tier-equivalencies";

export function SettingsPage(): React.ReactElement {
  const isAdmin = useIsAdmin();
  const search = useSearch({ from: "/app/settings" }) as { tab?: SettingsTab };
  const navigate = useNavigate();
  const tab: SettingsTab = search.tab ?? "crew";

  if (!isAdmin) return <Navigate to="/" />;

  return (
    <div className="mx-auto max-w-5xl p-6">
      <h1 className="mb-4 text-2xl font-semibold">Settings</h1>
      <Tabs value={tab} onValueChange={(v) => void navigate({ to: "/settings", search: { tab: v as SettingsTab } })}>
        <TabsList>
          <TabsTrigger value="crew">Crew</TabsTrigger>
          <TabsTrigger value="rates">Rates</TabsTrigger>
          <TabsTrigger value="airports">Airports</TabsTrigger>
          <TabsTrigger value="tier-equivalencies">Tier Equivalencies</TabsTrigger>
        </TabsList>
        <TabsContent value="crew">
          <CrewTab />
        </TabsContent>
        <TabsContent value="rates">
          <RatesTab />
        </TabsContent>
        <TabsContent value="airports">
          <AirportsTab />
        </TabsContent>
        <TabsContent value="tier-equivalencies">
          <TierEquivalenciesTab />
        </TabsContent>
      </Tabs>
    </div>
  );
}
